import React from 'react';

export const DiscountBadge = () => (
  <div className="cart-popup__discount-badge discount-badge">
    <p><b>Subscribe using code FIRSTMONTH</b> during checkout to save 30% on your first month</p>
  </div>
);
